import axios from "axios";
import {deleteField, doc, getDoc, setDoc, updateDoc} from "firebase/firestore";
import {v4 as uuidv4} from "uuid";
import {db} from "../../config/firebase";
import {PROJECT_VERSION_COLLECTION, PROJECTS_COLLECTION} from "../../db/collections";
import {FlowProjectRepository} from "../../repositories/FlowProjectRepository";
import {SubProjectRepository} from "../../repositories/ProjectRepository";

// Snapshot of a sub project's Firebase flow as a new version document (project_versions/{versionUid}).
// The flow document no longer keeps a `versions` array: it is left out of the snapshot and removed from the flow.
// Returns the versionUid.
export const createFlowVersion = async (flowUid, username) => {
  const flowRef = doc(db, PROJECTS_COLLECTION, flowUid);
  const snapshot = await getDoc(flowRef);
  const flow = snapshot.data();
  if (!flow) throw new Error("The sub project's flow was not found");

  const {versions, ...content} = flow;
  const versionUid = uuidv4();
  await setDoc(doc(db, PROJECT_VERSION_COLLECTION, versionUid), {
    ...content,
    id: versionUid,
    projectId: flowUid,
    createdAt: new Date().getTime(),
    createdBy: username || null,
  });
  if (versions !== undefined) {
    await updateDoc(flowRef, {versions: deleteField()});
  }
  return versionUid;
};

// Sends the flow's current export to the chatbot backend, like the legacy Save
const pushFlowToBackend = async (flowUid, subProjectId) => {
  const exported = await axios.get(`${process.env.REACT_APP_FIREBASE_FUNCTIONS_URL}/api/apiProject/${flowUid}`);
  // await FlowProjectRepository.updateFlow({id: subProjectId, project: exported?.data || null});
};

// Saves the sub project's flow as a STAGE or PRODUCTION version: Firebase snapshot, chatbot backend update,
// then the version is recorded in usermanagement (which numbers it and makes it the stage / production version).
// Returns the created ProjectVersionDTO.
export const saveSubProjectVersion = async ({subProject, type, username}) => {
  if (!subProject?.flowUid) throw new Error("This sub project has no flow");
  const versionUid = await createFlowVersion(subProject.flowUid, username);
  await pushFlowToBackend(subProject.flowUid, subProject?.id);
  const response = await SubProjectRepository.createVersion(subProject.id, {versionUid, type});
  return response?.data;
};
